import style from "@/styles/pages/AcceptTerms/AcceptTerms.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import { useEffect, useState } from "react";
import { setMeridianCommunication } from "@/slices/credentialSlice";
import { RootState } from "@/store/dtm";
import clsx from "clsx";
import { useForm } from "react-hook-form";
import FadeTransition from "@/styles/animation/FadeTransition";
import { setSingleClickInsightEvent } from "@/lib/util";

export default function AcceptTerms() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isTermsAccepted, setIsTermsAccepted] = useState(false);

    const application = useSelector(
        (state: RootState) => state.application.application
    );
    const methods = useForm({
        defaultValues: {
            meridianCommunication: false,
        },
    });

    const onSubmit = (data: any) => {
        if (isTermsAccepted) {
            dispatch(setMeridianCommunication(data.meridianCommunication));
            application.isCoApplicant ? navigate("/joint/create-profile") : navigate("/single/create-profile");
        }
    };

    const onError = (errors: object) => {
        console.log(errors);
    }

    const handleTermsToggle = (e: any) => {
        setIsTermsAccepted(e.target.checked);
    };

    useEffect(() => {
        setSingleClickInsightEvent("applicationType", "Sign-Up Selected")
    }, []);

    return (
        <FadeTransition>
            <main aria-labelledby="main-content">
                <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
                    <div className="main-container max-md:mt-10">
                        <div className="grid grid-cols-1 md:grid-cols-1 sm:hidden mt-10">
                            <div>
                                <img src="assets/acceptterms.svg" width="250" height="250" alt="accept-meridian-lending-terms"></img>
                            </div>
                        </div>
                        <div className={style.contentContainer}>
                            <div className="flex flex-col max-xs:px-3 max-md:items-center" style={{ maxWidth: "65%", paddingRight: "10%" }}>
                                <div className={style.emHeading}>
                                    <div className="grid grid-cols-1">
                                        <h1>Welcome to Meridian Lending</h1>
                                        <p>
                                            Before we start we need to get your consent.
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-5 flex flex-col-reverse">
                                    <label></label>
                                    <input
                                        id="termsAccepted"
                                        type="checkbox"
                                        checked={isTermsAccepted}
                                        onChange={handleTermsToggle}
                                        className="accent"
                                    />
                                    <label htmlFor="termsAccepted">
                                        <p className="sub-heading ml-7 -mt-5">
                                            I have read and agree to Meridian Credit Union's <a className="active" style={{ textDecoration: "underline" }}
                                                target="_blank" href="https://www.meridiancu.ca/about-meridian/privacy-and-security?_gl=1*11lr0k1*_ga*MTA5MzU5NzM4NS4xNjg4MDQ2ODM4*_ga_6D78MN23LS*MTY4ODA0NjgzOC4xLjEuMTY4ODA0Njg3Ni4yMi4wLjA">privacy statement</a> for the Protection of Personal Information as it pertains to the collection and management of my personal information.
                                        </p>
                                    </label>
                                </div>
                                <div className="mt-5 flex flex-col-reverse">
                                    <label></label>
                                    <input
                                        type="checkbox"
                                        className="accent"
                                        id="meridianCommunication"
                                        {...methods.register("meridianCommunication")
                                        } />
                                    <label htmlFor="meridianCommunication">
                                        <p className="sub-heading ml-7 -mt-5">
                                            <b>Optional: </b>I would like to receive emails about Meridian’s special offers and news. I understand that I can withdraw consent at any time.
                                        </p>
                                    </label>
                                </div>
                                <div className="mb-5">
                                    <button
                                        type="submit"
                                        className={clsx(isTermsAccepted ? "" : "disabled", "primary mt-5 w-full sm:w-28 h-11 px-6")}>
                                        Get Started
                                    </button>
                                </div>
                            </div>


                            <div className="grid grid-cols-1 md:grid-cols-1 max-sm:hidden">
                                <div>
                                    <img src="assets/acceptterms.svg" width="300" height="300" alt="accept-meridian-lending-terms"></img>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </main>
        </FadeTransition>
    );
}